
/**
 * @desc 有问题请联系 wangqq1
 */

require('../../common/js/zepto.js');
require('commonjs/zepto.mpopup.v2');

let md_login_model = require('mmd.common.no_ui_login_register');

let Tip_model = require('../module/tip_model');
let tip_model = new Tip_model.Tip_model();



// 淘系

function popup_vertical_align() {
    let $popups = $('.mod_tips_popup, .mod_popup');
    $popups.css('top', ($(window).height() - $popups.height()) / 2 - 50);
}

let memberUrl = 'http://bvip.m.tmall.com/crm/member.htm?id=201749140';

//注册会员弹框
function showMemberConfirmPop(content = '请先注册会员再参与活动') {
    let $popup = new Mpopup({
        title: '您还不是会员',
        content: content,
        type: 'confirmV2',
        destroyAfterClose: true,
        clickMaskClose: true,
        buttons: [{tpl: '<span class="mod_popup_btn" data-mpopup-confirm>立即注册</span>'}],
        onConfirm: function () {
            Tida.pushWindow(memberUrl);
        }
    });
    $popup.show();
    popup_vertical_align()
}



// 商城
let rnd = new Date().getTime().toString();
let cover_id = 'common_login_cover_'+rnd;
let phoneid = 'common_login_phone_'+rnd;
let getcodeid = 'common_login_get_code_'+rnd;
let codeid = 'common_login_code_'+rnd;
let submitbtnid = 'common_login_btn_'+rnd;
let imglayerid = 'common_login_img_layer_'+rnd;
let imgid = 'common_login_img_'+rnd;
let imgcodeid = 'common_login_img_input_'+rnd;
let imgcodebtnid = 'common_login_img_btn_'+rnd;

function getCookie(name) {
    let reg = new RegExp("(^| )" + name + "(?:=([^;]*))?(;|$)"),
        val = document.cookie.match(reg);
    return val ? (val[2] ? unescape(val[2]) : "") : null;
}

function setCookie(name, value, expires, path, domain, secure) {
    var exp = new Date(),
        expires = arguments[2] || null,
        path = arguments[3] || "/",
        domain = arguments[4] || null,
        secure = arguments[5] || false;
    expires ? exp.setMinutes(exp.getMinutes() + parseInt(expires)) : "";
    document.cookie = name + '=' + encodeURIComponent(value) + (expires ? ';expires=' + exp.toGMTString() : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
}

function loadCss(path){
    if(!path) return null;

    return new Promise((resolve, reject) =>{

        let link_dom;
        if(!window["_loadCss"] || window["_loadCss"].indexOf(path) < 0){
            link_dom = document.createElement('link');
            link_dom.setAttribute('type', 'text/css');
            link_dom.setAttribute('rel', 'stylesheet');
            link_dom.setAttribute('href', path);
            link_dom.setAttribute("id", "loadCss" + Math.random());
            link_dom.onload = function() {

                window["_loadCss"] ? (window["_loadCss"] += "|" + path) : (window["_loadCss"] = "|" + path);
                resolve();
            };
            link_dom.onerror = function() {
                reject();
            };
            document.getElementsByTagName("head")[0].appendChild(link_dom);
        }
    });
}

function start_login(success_cb, fail_cb){

    let login = md_login_model.init();

    let params = {
        beforerequest: function () {
            $('#'+cover_id).show();
            $('#'+codeid+',#'+imgcodeid).val('');
            window.pop_login_need_reg = true;
        },
        phoneid: phoneid,
        getcodeid: getcodeid,
        codeid: codeid,
        submitbtnid: submitbtnid,
        imglayerid: imglayerid,
        imgid: imgid,
        imgcodeid: imgcodeid,
        imgcodebtnid: imgcodebtnid,
        success: function () {
            $('#'+cover_id+',#'+imglayerid).hide();
            $('#'+imgid).attr('src','');

            if(typeof(success_cb) == "function"){
                var re_login = typeof window.pop_login_need_reg != 'undefined';
                success_cb(re_login);
            }
        },
        fail:function(){
            $('#'+cover_id+',#'+imglayerid).hide();
            $('#'+imgid).attr('src','');

            if(typeof(fail_cb) == "function"){
                var re_login = typeof window.pop_login_need_reg != 'undefined';
                fail_cb(re_login);
            }
        }
    };
    //console.log(params);
    login.start(params);
}

function init_login_model_dom(){
    if($('#'+cover_id).length >0){
        return;
    }

    let str_template=`<div class="common_login_cover" id="common_login_cover_${rnd}">
           <div class="common_login_cover_inner">
              <div class="js-close-layer close-layer">
                  <div class="js-close-layer-inner close-layer-inner"></div>
               </div>
                <div class="common_login_img_layer" id="common_login_img_layer_${rnd}" >
                    <div class="common_login_row">
                        <img id="common_login_img_${rnd}" src="//img.mdcdn.cn/h5/img/placeholder_10040.png" alt="">
                    </div>
                    <div class="common_login_row" style="display: flex;">
                        <input class="common_login_img_input" id="common_login_img_input_${rnd}" type="text" placeholder="图片验证码" >
                        <div class="common_login_img_btn" id="common_login_img_btn_${rnd}" >确 定</div>
                    </div>
                </div>
                <div class="common_login_row">
                    <input class="common_login_phone" id="common_login_phone_${rnd}" type="text" placeholder="请输入手机号" >
                </div>
                <div class="common_login_row" style="display: flex;">
                    <input class="common_login_code" id="common_login_code_${rnd}" type="text" placeholder="请输入验证码" >
                    <div class="common_login_get_code" id="common_login_get_code_${rnd}">获取验证码</div>
                </div>
                <div class="common_login_btn_out">
                    <div class="common_login_btn" id="common_login_btn_${rnd}">确 定</div>
                </div>
            </div>
        </div>`;

    $('body').append(str_template);
    $('#'+cover_id+' .js-close-layer').click(function () {
        $('#'+cover_id).hide();
    })
}



// 京东
function invoke_native_login_page() {
    JSSDK.Isv.requestLogin(function (res) {
        setTimeout(function () {
            console.log("未登录，唤起原生登录页！");

            go_link(joinMemberUrl);

            if (res.data === 1) {
                tip_model.tip_show('登录成功');

            } else if (res.data === 0) {
                tip_model.tip_show('登录失败');
            }
        }, 0);
    });
}


class Platform {
    constructor() {

        // 淘系
        try{
            if (window.navigator.userAgent.indexOf('AliApp') > 0) { // 在淘系环境
                this.p = this.load_script('//g.alicdn.com/tmapp/tida/3.2.76/tida.js?appkey=23328932').then(() => {

                    if (Tida && Tida.isSupportedApp) {
                        this.platform = 'tao';
                    }

                }, () => {
                    console.error('环境错误');
                    tip_model('环境参数错误', 2000);
                });
                return;
            }
        } catch (res){}

        // 京东
        try{
            if (window.navigator.userAgent.split(';')[0] === 'jdapp') { // 在京东环境
                this.p = this.load_script('//g.mdcdn.cn/js/jd.jssdk.min.js').then(() => {

                    if (JSSDK && JSSDK.Client && JSSDK.Client.isJDApp()) {
                        this.platform = 'jd';
                    }

                }, () => {
                    console.error('环境错误');
                    tip_model('环境参数错误', 2000);
                });
                return;
            }
        } catch (res){}

        // 商城
        // 加载弹窗 css、 dom
        this.p = loadCss('https://g.mdcdn.cn/h5/css/act/internal/common_login.css?t=201605123').then(() =>{
            init_login_model_dom();
            this.platform = 'md';
        });

        // 设置MachineKey
        let mk = getCookie('midea_mk');
        if (!mk || mk.length != 31) {
            this.load_script('https://mall.midea.com/next/machine_key/getmachinekey');
            window.callback = function (obj) {
                if (obj.errcode === 0) {
                    setCookie('midea_mk', obj.machinekey, 26280000, '/', document.domain);
                }
            }
        }
    }

    load_script(url) {
        return new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.charset = 'utf-8';
            script.onload = script.onreadystatechange = function () {
                resolve();
            };
            script.onerror = function () {
                script.onload = script.onreadystatechange = script.onerror = null;
                script.parentNode && (script.parentNode.removeChild(script));
                script = null;
                reject();
            };
            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }

    // 判断会员登录状态
    is_login(success_callback = null, fail_callback = null) {
        this.p.then(() => {
            console.log(this.platform);
            this['is_' + this.platform + '_login'](success_callback, fail_callback);
        });
    }

    is_tao_login(success_callback, fail_callback) {

        // 如果本地已经有 cookie 说明已经登录，不需要再使用登陆过程获取 cookie，直接执行（目前 cookie 种在淘系域名下面）
        if (getCookie('uid') && getCookie('sukey')) {
            console.log('tao_has_login_before');
            typeof success_callback === 'function' && success_callback();
            return;
        }

        console.log('begin_tao_re_login');
        Tida.doAuth(false, function (data) {
            if (data.finish) {
                Tida.mixNick({
                    sellerNick: "美的会员",
                    console: 0
                }, function (data) {
                    if (data.mixnick) {
                        $.ajax({
                            'type': 'GET',
                            'url': 'https://mvip.midea.cn/act/taobao/api/get_user_info_v2?callback=?',
                            'data': {
                                nick: data.mixnick
                            },
                            'dataType': 'jsonp',
                            'timeout': 10000,
                            'success': function (data) {

                                // 如果页面授权之后，查询用户信息失败，就弹窗让用户去绑定
                                if (data.errcode != 0) {
                                    showMemberConfirmPop();
                                    typeof fail_callback === 'function' && fail_callback();
                                    return;
                                }

                                typeof success_callback === 'function' && success_callback();
                            },
                            'error': function (xhr, type) {
                                showMemberConfirmPop();
                                typeof fail_callback === 'function' && fail_callback();
                            }
                        });

                    } else {
                        showMemberConfirmPop();
                        typeof fail_callback === 'function' && fail_callback();
                    }
                });

            } else {
                showMemberConfirmPop();
                typeof fail_callback === 'function' && fail_callback();
            }
        });
    }

    is_jd_login(successCallback, failCallback) {

        // 如果本地已经有缓存，就不再进行授权过程
        let uid = window.localStorage.uid;
        let sukey = window.localStorage.sukey;
        if (uid && sukey) {
            console.log('jd_has_login_before');
            successCallback && successCallback();
            return;
        }

        console.log('begin_jd_re_login');
        let _ = this;
        if (JSSDK.Client.isJDApp()){     // 是否在京东APP内
            JSSDK.Isv.isAppLogin(function (res) {
                setTimeout(function () {
                    if (res.data == 1) { // 已登录，开始获取 token
                        JSSDK.Isv.requestIsvToken({
                            url: window.location.href,
                            id: ""
                        }, function (res) { // 成功获取 token

                            setTimeout(function () {

                                if (res.data) { // res.data 是一串字符串 pin

                                    _.jd_query({
                                        url: 'https://mvip.midea.cn/my/muc/get_jd_user_info?pin=' + res.data
                                    }).then((res) => {

                                        // 本地存储登录信息
                                        window.localStorage.setItem("uid", res.data.lUid);
                                        window.localStorage.setItem("sukey", res.data.strCurSession);

                                        successCallback && successCallback();

                                    }, (response) => {
                                        invoke_native_login_page();
                                        failCallback && failCallback(response);
                                    });

                                } else {
                                    invoke_native_login_page();
                                    failCallback && failCallback(res);
                                }
                            }, 0);
                        }, function(res) {
                            alert('request token fail');
                            invoke_native_login_page();
                            failCallback && failCallback(res);
                        })

                    } else if (res.data == 0) { // 未登录

                        invoke_native_login_page();
                        failCallback && failCallback(res);
                    }
                }, 0);
            });
        } else {
            tip_model.tip_show('not in jd', 2000);
        }
    }

    is_md_login(successCallback, failCallback) {

        if (getCookie('uid') && getCookie('sukey')) { // 已有登录信息，登陆成功，对应 cgi 层 check_online
            typeof successCallback === 'function' && successCallback();
            return;
        }

        typeof failCallback === 'function' && failCallback();
    }

    // 会员登录
    login(success_callback = null, fail_callback = null) {
        this.p.then(() => {
            console.log(this.platform);
            this[this.platform + '_login'](success_callback, fail_callback);
        });
    }

    tao_login(success_callback, fail_callback) {
        this.is_tao_login(success_callback, fail_callback);
    }

    jd_login(success_callback, fail_callback) {
        this.is_jd_login(success_callback, fail_callback);
    }

    md_login(success_callback, fail_callback) {

        if (getCookie('uid') && getCookie('sukey')) { // 已有登录信息，登陆成功，对应 cgi 层 check_online
            typeof success_callback === 'function' && success_callback();
            return;
        }

        // 调起弹窗登录
        start_login(() => {
            typeof success_callback === 'function' && success_callback();
        }, () => {
            typeof fail_callback === 'function' && fail_callback();
        });
    }

    // 链接跳转
    go_link(url = null) {
        url && this[this.platform + '_go_link'](url);
    }

    tao_go_link(url = null) {

        url && Tida.pushWindow(url);
    }

    jd_go_link(url = null) {
        url && JSSDK.Native.Jump.Mpage.toUrl({url});
    }

    md_go_link(url = null) {
        if (!url) return;
        window.location.href = url;
    }

    // 请求接口
    query(obj = null) {
        if (!obj) {
            return;
        }

        return this.p.then(() => {
            console.log(this.platform);
            return this[this.platform + '_query'](obj);
        });
    }

    tao_query(obj) {
        return new Promise((resolve, reject) => {
            $.ajax({
                'type': 'GET',
                'url': obj.url,
                'data': obj.data,
                'dataType': 'jsonp',
                'timeout': 10000,
                success (data) {
                    resolve(data);
                },
                error(res) {
                    reject(res);
                }
            });
        })
    }

    jd_query(obj) {
        if (!obj.url) {
            console.error('url can not be null');
            return;
        }

        let proxy_jd = 'https://meidi-isv.isvjcloud.com/jingdong/index/proxy';

        let uid = window.localStorage.uid ? window.localStorage.uid : '';
        let sukey = window.localStorage.sukey ? window.localStorage.sukey : '';

        let params = '';
        if (obj.data) {
            let data = obj.data;
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    params += '&' + key + '=' + data[key];
                }
            };
            if (params) {
                params = '?' + params.slice(1);
            }
        }

        let new_url = proxy_jd + '?url=' + encodeURIComponent(obj.url + params) + '&uid=' + uid + '&sukey=' + sukey;

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: new_url,
                data: {},
                dataType: 'json',
                success (data) {
                    resolve(data);
                },
                error(res) {
                    reject(res);
                }
            });
        })
    }

    md_query(obj) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: obj.type ? obj.type : 'POST',
                url: obj.url,
                data: obj.data,
                dataType: 'json',
                success (data) {
                    resolve(data);
                },
                error(res) {
                    reject(res);
                }
            });
        })
    }

    tao_page_watcher(success_callback) {
        let _ = this;
        this.tao_watchId = Tida.pageVisibility.watch(function(result){
            // ~ visible 1 为激活 0 为隐藏
            // ~ 移动端按 Home 键回到桌面 js 会挂起不执行，所有再次回到页面该方法会先后一起调用，注意区别该值
            if (result.visible == 1 ) { // 页面显示

                _.tao_check_online_member(false, function(data){

                    // 如果页面授权之后，查询用户信息失败，就弹窗让用户去绑定
                    if (data.errcode != 0) {
                        showMemberConfirmPop();
                        return;
                    }

                    typeof success_callback === 'function' && success_callback();

                }, function(){

                    showMemberConfirmPop();
                });
            } else { // 页面隐藏

            }
        });
    }
}


module.exports = Platform;



// WEBPACK FOOTER //
// ./module/common_for_mall_tao_jd.js